import app from 'flarum/common/app';
export function showingOriginal(model) {
  return !model.isTranslated?.() && !!model.showingOriginal;
}
export default function toggleOriginal(model) {
  const type = model.data.type;
  const id = model.id();
  if (!type || !id) return Promise.resolve();
  const showOriginal = !!model.isTranslated?.();
  model.loadingOriginal = true;
  return app.store.find(type, id, showOriginal ? {
    showOriginal: true
  } : {}).then(() => {
    model.showingOriginal = showOriginal;
  }).finally(() => {
    model.loadingOriginal = false;
    m.redraw();
  });
}
flarum.reg.add('glowingblue-translate', 'common/utils/toggleOriginal', toggleOriginal);